module.exports = "/subscriptions/assets/eaed60fa3d04ccf5fabb31fd3f793205.png";